import NiceModal from "@ebay/nice-modal-react";
import P from "components/P";
import Inline from "layouts/container/Inline";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import PaddingWrapper from "layouts/wrapper/PaddingWrapper";
import ModalBase from "modals/base/ModalBase";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { createRef, useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { decode, encode } from "shared/utils/Utils";
import QuillViewer from "components/inputs/richEditor/QuillViewer";
import CheckBox from "components/inputs/checkBox/CheckBox";
import AdminCustomButton, { style } from "components/buttons/AdminCustomButton";
import QuillEditor from "components/inputs/richEditor/QuillEditor";
import InputText from "components/inputs/InputText";
import DatePicker from "components/inputs/datePicker/DatePicker";
import { adminRequester } from "App";
import { useNavigate } from "react-router-dom";

const ShowDataModal = NiceModal.create((props) => {
  const { t } = useTranslation();
  // const { isMobile } = useContext(BrowserDetectContext);
  const [mounted, setMounted] = useState(false);
  const { requester, limit, headers } = props;
  const [withHeader, withFooter] = [true, false];
  const [width, height] = ["min(95%, 1280px)", "80vh"];
  const [maxPage, setMaxPage] = useState(0);
  const [page, setPage] = useState(0);
  const [data, setData] = useState([]);
  const withCloseButton = true;
  const clickOutsideToClose = true;
  const modal = useRef();

  useEffect(() => setMounted(true), []);

  useEffect(() => {
    if (mounted) {
      requester?.({ limit: limit, offset: page * limit }, (result) => {
        setData(result.data);
        setMaxPage(Math.ceil(result.count / limit));
      });
    }
  }, [mounted, page]);

  return (
    <ModalBase
      borderRadius={"10px"}
      headerStyle
      title={props.title || "상세"}
      ref={modal}
      width={width}
      height={height}
      withHeader={withHeader}
      withFooter={withFooter}
      withCloseButton={withCloseButton}
      clickOutsideToClose={clickOutsideToClose}
    >
      <PaddingWrapper padding={30}>
        <div style={{ height: "70vh", overflowY: "auto" }}>
          <VerticalFlex gap={10} height="100%">
            <FlexChild height="max-content">
              <HorizontalFlex>
                {headers?.map((header, index) => (
                  <FlexChild
                    key={`${header?.label}_${index}`}
                    width={header?.width ? header.width : null}
                  >
                    <P weight="bold">{header?.label}</P>
                  </FlexChild>
                ))}
              </HorizontalFlex>
            </FlexChild>
            <FlexChild height="max-content">
              <VerticalFlex gap={10}>
                {data?.map((d, rowIndex) => {
                  return (
                    <HorizontalFlex key={d?.label}>
                      {headers.map((header, index) => {
                        let value = header?.Cell
                          ? header.Cell({
                              cell: d[header?.code],
                              row: d,
                              index: rowIndex + page * limit,
                            })
                          : header?.code
                          ? d[header.code]
                          : "-";

                        if (
                          typeof value === "string" ||
                          typeof value === "number"
                        )
                          value = <P>{value}</P>;
                        return (
                          <FlexChild key={`${header.label}_${index}_column`}>
                            {value}
                          </FlexChild>
                        );
                      })}
                    </HorizontalFlex>
                  );
                })}
              </VerticalFlex>
            </FlexChild>

            {maxPage > 0 && (
              <HorizontalFlex
                marginTop="auto"
                height="max-content"
                justifyContent="center"
                gap={10}
              >
                <FlexChild width="max-content">
                  <AdminCustomButton
                    text="《"
                    onClick={() => setPage(0)}
                    disabled={page === 0}
                  />
                </FlexChild>
                <FlexChild width="max-content">
                  <AdminCustomButton
                    text="〈"
                    onClick={() =>
                      setPage(Math.max(0, page - 10 - (page % 10)))
                    }
                    disabled={page === 0}
                  />
                </FlexChild>
                {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
                  .filter((i) => i + (page - (page % 10)) < maxPage)
                  .map((i) => {
                    const now = i + (page - (page % 10));
                    return (
                      <FlexChild key={`page_${now}`} width="max-content">
                        <AdminCustomButton
                          text={i + 1}
                          style={style.white_border}
                          selected={now === page}
                          onClick={() => setPage(now)}
                        />
                      </FlexChild>
                    );
                  })}
                <FlexChild width="max-content">
                  <AdminCustomButton
                    text="〉"
                    disabled={page === Math.ceil(maxPage - 1)}
                    onClick={() =>
                      setPage(
                        Math.min(
                          Math.ceil(maxPage - 1),
                          page + 10 - (page % 10)
                        )
                      )
                    }
                  />
                </FlexChild>
                <FlexChild width="max-content">
                  <AdminCustomButton
                    text="》"
                    disabled={page === Math.ceil(maxPage - 1)}
                    onClick={() => setPage(Math.ceil(maxPage - 1))}
                  />
                </FlexChild>
              </HorizontalFlex>
            )}
          </VerticalFlex>
        </div>
      </PaddingWrapper>
    </ModalBase>
  );
});

export default ShowDataModal;
